import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

import {
  type Filter,
  FilterId,
  FilterType,
  type SingleValueFilter,
} from '../types/filters';
import { stripVersionFromTaxonomyId } from './taxonomyHelpers';

export const getCustomRoleFilter = (filter: Filter, filters: Filter[]) => {
  if (filter.type !== FilterType.TREE) {
    return {};
  }

  const roleTaxonomyFilter = filters.find(
    (f): f is SingleValueFilter<CustomRoleTaxonomySelection> =>
      f.id === FilterId.ROLE_TAXONOMY && f.type === FilterType.VALUE
  );

  const taxonomySelection = roleTaxonomyFilter?.value ?? { default: true };

  return {
    custom_role: {
      taxonomyId: stripVersionFromTaxonomyId(taxonomySelection),
      entities: filter.selections.map((selection) => {
        const selectionIds = selection.id.split('_');
        const lastId = selectionIds[selectionIds.length - 1];
        return { id: lastId, levelId: selection.levelId };
      }),
    },
  };
};
